// extracted by mini-css-extract-plugin
export default {"accountBreadcrumbs":"Dn-z","hideOnMobile":"En-z"};